export function tryCatchFallback<T, F>(
  fn: () => T,
  fallbackValue: F,
  errorHandler?: (error: unknown) => void,
): T extends Promise<infer R> ? Promise<R | F> : T | F {
  try {
    const result = fn()
    if (result instanceof Promise) {
      return result.catch((error) => {
        if (errorHandler) {
          errorHandler(error)
        }
        return fallbackValue
      }) as T extends Promise<infer R> ? Promise<R | F> : T | F
    }
    return result as T extends Promise<infer R> ? Promise<R | F> : T | F
  } catch (error) {
    if (errorHandler) {
      errorHandler(error)
    }
    return fallbackValue as T extends Promise<infer R> ? Promise<R | F> : T | F
  }
}
